export default __webpack_public_path__ + "static/media/u_pen.10e032fd.svg";